import React, { FC, PropsWithChildren } from 'react'
import { Drawer, Grid, IconButton, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

interface FilterDrawerProps {
  open: boolean
  onClose: () => void
  title?: string
}

// Right-side drawer for list filters: full-screen on phones, fixed panel on desktop.
// MUI Drawer traps focus while open and returns it to the trigger on close.
export const FilterDrawer: FC<PropsWithChildren<FilterDrawerProps>> = ({ open, onClose, title = 'All filters', children }) => {
  return (
    <Drawer anchor="right" open={open} onClose={onClose} PaperProps={{ sx: { width: { xs: '100%', sm: 400 }, maxWidth: '100%', p: 3, boxSizing: 'border-box' } }}>
      <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
        <Grid item>
          <Typography variant="h6">{title}</Typography>
        </Grid>
        <Grid item>
          <IconButton aria-label="Close filters" onClick={onClose} sx={{ width: 44, height: 44 }}>
            <CloseIcon />
          </IconButton>
        </Grid>
      </Grid>
      {children}
    </Drawer>
  )
}
